import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Location} from '@on-the-go-web/sdk';
import {LocationPickerList} from '../location-picker-list/location-picker-list';

export interface LocationPickerDialogData {
  locations: Location[];
  currentLocationId: string | null;
}

// Opened from the sidebar's location switcher — shows the same location list
// as the bottom nav's bottom sheet, but as a dialog. Closes with the picked
// location id and leaves navigation to the caller, which switches location
// while staying on the current page.
@Component({
  selector: 'otg-location-picker-dialog',
  imports: [LocationPickerList],
  templateUrl: './location-picker-dialog.html',
  styleUrl: './location-picker-dialog.scss',
})
export class LocationPickerDialog {
  private _dialogRef = inject(MatDialogRef<LocationPickerDialog, string>);
  private _router = inject(Router);
  private _data = inject<LocationPickerDialogData>(MAT_DIALOG_DATA);

  locations = this._data.locations;
  currentLocationId = this._data.currentLocationId;

  selectLocation(locationId: string): void {
    this._dialogRef.close(locationId);
  }

  addLocation(): void {
    this._dialogRef.close();
    this._router.navigate(['/add-business']);
  }
}
